"use client";
import { PrizeTypes } from "@/api/home";
import { Card } from "@/components/Card";
import { Tabs } from "antd-mobile";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { FC } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./prize.module.scss";
interface Props {
    data: PrizeTypes[];
    type: "list" | "card";
}

const HomePrize: FC<Props> = (props) => {
    const { data, type } = props;
    const t = useTranslations("HomePage");
    const tt = useTranslations("Game");

    if (!data?.length) return null;

    return (
        <div className={"my-[0.0694rem] px-[.1rem] pb-[.0rem]"}>
            {/* <div className={"mb-[0.0347rem]"}>{t("prize")}</div> */}
            {type === "card" && (
                <>
                    <div className="mb-[.1rem] text-[0.13rem] font-bold">
                        Grandes Vitórias Recentes
                    </div>
                    <Swiper
                        slidesPerView={5.2}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        // freeMode={true}
                        loop
                        autoplay={{
                            delay: 3000,
                        }}
                        modules={[
                            Autoplay,
                            //  FreeMode
                        ]}
                        className="mySwiper"
                        // style={{
                        //     transitionTimingFunction: "linear !important",
                        //     transitionDuration: "3000ms",
                        // }}
                    >
                        {data.map((prize, index: number) => (
                            <SwiperSlide key={index}>
                                <div className={"w-[100%]"} style={{ borderRadius: ".1rem" }}>
                                    <Card
                                        item={prize}
                                        className="aspect-[169/234] h-[auto_!important]"
                                    />
                                    <div className={"pb-[0.0347rem] text-[0.12rem]"}>
                                        <p className={"mt-[.05rem] text-[#b77fff]"}>
                                            {prize.phone
                                                ? prize.phone.slice(0, 3) +
                                                  "*****" +
                                                  prize.phone.slice(-3)
                                                : ""}
                                        </p>
                                        <p className={"text-[0.11rem] text-[#43c937]"}>
                                            R${prize.amount}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </>
            )}

            {type === "list" && (
                <div className={styles.Prize}>
                    <div className="items flex flex-row items-center justify-between">
                        <Tabs>
                            <Tabs.Tab title="Recente" key="recente"></Tabs.Tab>
                            {/* <Tabs.Tab title="Vitórias" key="Vitórias"></Tabs.Tab> */}
                        </Tabs>
                        {/* <div>
                        <div className={styles.desc}>Jogando Agora</div>
                        <div className="pl-[.1rem]">52603</div>
                    </div> */}
                    </div>
                    <div className="relative mt-[.15rem] rounded-[.1rem] bg-[#1f2830] px-[.15rem]">
                        <div className={styles.item}>
                            <div>Jogos</div>
                            <div>Jogador</div>
                            {/* <div>Aposta</div> */}
                            <div>Pagamento</div>
                        </div>
                        <Swiper
                            slidesPerView={10}
                            direction="vertical"
                            loop
                            autoplay={{
                                delay: 1000,
                            }}
                            allowTouchMove={false}
                            modules={[Autoplay]}
                            height={500}
                            style={{ height: "500px" }}
                        >
                            {[...(data || []), ...(data || [])].map((prize, index: number) => (
                                <SwiperSlide key={index}>
                                    <div
                                        className={clsx(styles.item, styles.normal, {
                                            [styles.even]: index % 2 === 1,
                                        })}
                                    >
                                        <div>
                                            <span>{prize.game_name}</span>
                                        </div>
                                        <div>
                                            {prize.phone
                                                ? prize.phone.slice(0, 3) +
                                                  "*****" +
                                                  prize.phone.slice(-3)
                                                : ""}
                                        </div>
                                        {/* <div>Aposta</div> */}
                                        <div>R${prize.amount}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="absolute bottom-[0] left-[0] right-[0] top-[0] z-[2]"></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HomePrize;
